var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.componentSize},[_c('img',{staticClass:"heroll__logo",attrs:{"src":require("../../../assets/logo.webp"),"alt":"Heroll"}}),_c('h1',[_vm._v("Heroll")])])}
var staticRenderFns = []

export { render, staticRenderFns }